import { useForm } from "react-hook-form";
import { Suspense, useEffect, useMemo, useState } from "react";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { useColumnsModalInmb } from "../../utils/columnsModalInmb";
import { filtrosModalInmb } from "../../models/garantias";
import * as Yup from 'yup'
import validaRut from "../../../../utils/validaRut";
import { yupResolver } from "@hookform/resolvers/yup";
import { Dialog, DialogContent, DialogTitle, Grid2 } from "@mui/material";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import Tabla from "../../../../components/ui/materialui/tablaServerSelector";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import FilterListIcon from '@mui/icons-material/FilterList';
import { config } from '../../../../utils/config';
import InmobiliariaForm, { InmobiliariaWriteDto } from "../../../maestros/inmobiliarias/components/inmobiliariaForm";
import { exportExcel } from "../../../../utils/exportExcel";
import { AddTwoTone, SummarizeTwoTone } from "@mui/icons-material";

interface IProps {
    show: boolean;
    onHide: () => void;
    setTablaSeleccionada: React.Dispatch<React.SetStateAction<any | undefined>>;
}

const validationSchema = Yup.object().shape({
    rut: Yup.string().default('').nonNullable().test('valida-rut', 'RUT inválido', function (value) {
        return validaRut.rutFormat(value);
    })
});

const ModalInmobiliarias: React.FC<IProps> = (props) => {

    const [toggleFilterButtonClicked, setToggleFilterButtonClicked] = useState<boolean>(false);

    const [modalDetalle, setModalDetalle] = useState(false);
    const [inmobiliariaEditar, setInmobiliariaEditar] = useState<InmobiliariaWriteDto>();

    const {
        formState: { errors },
        handleSubmit,
        reset,
        control,
    } = useForm<filtrosModalInmb>({ resolver: yupResolver(validationSchema) })

    // const dataParentForm = props.watchParentForm();
    const urlApi = `${config.URL_API_SISCRED}siscred-api-maestros/v1/inmobiliarias/listar`;

    const controlTabla = useDataFetch(
        urlApi,
        new URLSearchParams('filters.status=ACTIVA'),
        true,
    )

    const renderizar = () => {
        controlTabla.fetchData();
    }

    const { COLUMNS } = useColumnsModalInmb({ renderizar, setInmobiliariaEditar, setModalDetalle });
    const columns = useMemo(() => COLUMNS, [control]);

    function filtrar(data: filtrosModalInmb) {

        if (data.nombre) {
            controlTabla.manejarCambiosFiltros(
                'filters.nombre',
                data.nombre.toString(),
            )
        }
        else {
            controlTabla.manejarCambiosFiltros(
                'filters.nombre',
                ''
            )
        }

        if (data.rut) {
            controlTabla.manejarCambiosFiltros(
                'filters.rut',
                data.rut.toString(),
            )
        } else {
            controlTabla.manejarCambiosFiltros('filters.rut', '')
        }

        controlTabla.fetchData()
    }

    const resetFiltros = () => {
        reset();
        controlTabla.manejarCambiosFiltros('filters.nombre', '');
        controlTabla.manejarCambiosFiltros('filters.rut', '');
    }

    useEffect(() => {
        resetFiltros();

        if (props.show)
            controlTabla.fetchData();

    }, [props.show]);



    function customOnHide() {
        props.onHide()
    }

    return (
        <Dialog
            open={props.show}
            onClose={props.onHide}
            fullScreen
        >
            <DialogTitle>
                Buscar inmobiliaria
            </DialogTitle>
            <DialogContent>
                <CustomAccordion
                    title='Filtros'
                    expandedDefault
                >
                    <div onClick={(e) => e.stopPropagation()}>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setToggleFilterButtonClicked(!toggleFilterButtonClicked);
                            handleSubmit(filtrar)(e);
                        }}>
                            <Grid2 container spacing={2} mt={2}>
                                <Grid2 size={{ xs: 12, lg: 4 }}>
                                    <InputText
                                        label="Nombre inmobiliaria"
                                        name="nombre"
                                        control={control}
                                        error={errors.nombre}
                                    />
                                </Grid2>

                                <Grid2 size={{ xs: 12, lg: 2 }}>
                                    <InputRut
                                        label="RUT inmobiliaria"
                                        name="rut"
                                        control={control}
                                        error={errors.rut}
                                    />
                                </Grid2>

                                <Grid2 size={{ xs: 12, lg: 6 }} display="flex" justifyContent="flex-end" alignItems={'center'}>
                                    <MButton
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        startIcon={<FilterListIcon />}
                                        onClick={() => {
                                            setToggleFilterButtonClicked(!toggleFilterButtonClicked);
                                            handleSubmit(filtrar)();
                                        }}
                                    >
                                        Filtrar
                                    </MButton>
                                </Grid2>
                            </Grid2>
                        </form>
                    </div>
                </CustomAccordion>
                <Suspense>
                    <Tabla
                        columns={columns}
                        control={controlTabla}
                        url={urlApi}
                        callApi={false}
                        setFilaSeleccionada={props.setTablaSeleccionada}
                        onHide={props.onHide}
                        toggleFilterButtonClicked={toggleFilterButtonClicked}
                        messageSingular="Inmobiliaria"
                        esMultiple={false}
                        // titulo={<TableHeader
                        //     title="Listado inmobiliaria"
                        //     control={controlTabla}
                        //     hideSearchFilter={true}
                        // />}

                        titulo={<TableHeader
                            title=""
                            control={controlTabla}
                            button={
                                <>
                                    <MButton variant="contained" startIcon={<AddTwoTone />}
                                        onClick={() => { setModalDetalle(true); setInmobiliariaEditar(undefined) }}>Nueva</MButton>
                                </>
                            }
                            buttonExport={
                                <>
                                    <MButton variant="contained" onClick={customOnHide}>
                                        seleccionar
                                    </MButton>
                                </>
                            }
                        />}

                    />
                </Suspense>

                <InmobiliariaForm show={modalDetalle} dataediting={inmobiliariaEditar} onHide={() => setModalDetalle(false)}
                refresh={() => controlTabla.fetchData()} 
                convenios={[
                    { value: '1', label: 'Convenio A', title: 'Pago contra firma de inmobiliaria' },
                    { value: '2', label: 'Convenio B', title: 'Pago al segundo día desde que firma el banco alzante' },
                    { value: '3', label: 'Convenio C', title: 'Pago a firma MetLife' },
                    { value: '4', label: 'Convenio D', title: 'Pago al quinto día de inscripción en CBR' },
                    { value: '5', label: 'Convenio E', title: 'Pago posterior a la salida del CBR' }
                ]}></InmobiliariaForm>
            </DialogContent>
        </Dialog>
    )
}

export default ModalInmobiliarias

